import { render, staticRenderFns } from "./multipleimitDetail.vue?vue&type=template&id=9d69a16c&scoped=true"
import script from "./multipleimitDetail.vue?vue&type=script&lang=js"
export * from "./multipleimitDetail.vue?vue&type=script&lang=js"
import style0 from "./multipleimitDetail.vue?vue&type=style&index=0&id=9d69a16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d69a16c",
  null
  
)

export default component.exports